import { render, staticRenderFns } from "./ObjectView.vue?vue&type=template&id=093fabe1&lang=pug"
import script from "./ObjectView.vue?vue&type=script&lang=js"
export * from "./ObjectView.vue?vue&type=script&lang=js"
import style0 from "./ObjectView.vue?vue&type=style&index=0&id=093fabe1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports